import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { supabase } from '../../../lib/supabase';

interface StatItem {
  numero: string;
  texto: string;
  icone: string;
}

const defaultStats: StatItem[] = [
  { numero: '500+', texto: 'Alunos Satisfeitos', icone: 'ri-user-star-line' },
  { numero: '50+', texto: 'Cursos Premium', icone: 'ri-book-open-line' },
  { numero: '98%', texto: 'Taxa de Satisfação', icone: 'ri-heart-line' },
  { numero: '24/7', texto: 'Suporte Disponível', icone: 'ri-customer-service-2-line' },
];

const StatsSection = () => {
  const [stats, setStats] = useState<StatItem[]>(defaultStats);

  useEffect(() => {
    carregarStats();
  }, []);

  const carregarStats = async () => {
    const { data } = await supabase
      .from('conteudo_inicio')
      .select('*')
      .eq('secao', 'stats')
      .maybeSingle();

    if (data?.dados_json?.items && data.dados_json.items.length > 0) {
      setStats(data.dados_json.items);
    }
  };

  return (
    <section className="py-24 px-8 lg:px-20 bg-gradient-dark">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="text-center"
            >
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-gold rounded-xl flex items-center justify-center">
                <i className={`${stat.icone || 'ri-star-line'} text-black text-3xl`}></i>
              </div>
              <div className="text-5xl lg:text-6xl font-black bg-gradient-gold-silver bg-clip-text text-transparent mb-3">
                {stat.numero}
              </div>
              <p className="text-gray-400 text-sm uppercase tracking-wider">
                {stat.texto}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
